import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { tileLayer, Layer, latLng, marker, icon } from "leaflet";

import { LanguageService } from '../../services';

@Component({
  selector: 'contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  imgurl: string = '../../assets/backgrounds/banquise_2.jpg'

  english: boolean;

  // *** Content *** //

  title: string;
  slogan: string;

  mail: string = "contact@eyesnap.fr"

  // *** Map *** //

  options = {
    layers: [
      tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
        maxZoom: 20,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        detectRetina: true
      }),
      marker([45.767340, 4.793320], {
        icon: icon({
          iconSize: [25, 41],
          iconAnchor: [13, 41],
          iconUrl: '../../assets/maps/marker-icon.png',
          shadowUrl: '../../assets/maps/marker-shadow.png',
        })
      })],
    zoom: 10,
    zoomControl: false,
    center: latLng(45.767340, 4.793320)
  };

  // ***************************** //

  constructor(private titleService: Title, private languageService: LanguageService) { }

  ngOnInit() {
    this.titleService.setTitle('eyeSnap - Contact')
    this.initContent();
  }

  onLanguage() {
    this.initContent();
  }

  // *** Content *** //

  initContent() {
    this.languageService.getLanguage()
      .subscribe(english => this.english = english);
    if (this.english) {
      this.title = 'Contact';
      this.slogan = 'Get in touch !';
    } else {
      this.title = 'Contact';
      this.slogan = 'Nous contacter';
    }
  }

}
